/** @var { FileManipulationControllerState } */
const STATE = {
  formFromStore: {
    batchFileName: null,
    entityGuid: null,
    batchFileType: null,
    batchFileConfigJSON: null,
    dependencyGroup: 0,
    fileNamePattern: null,
    useColumnPhysicalNames: true,
    delimiter: null,
    sheetConfigs: [],
    batchSize: 0,
  },

  ftpStorageList: [],
  batchList: [],
  entitiesList: null,
  addEditModal: {
    show: false,
    data: {},
  },
  batchFileListModal: {
    show: false,
    data: {},
  },
  addEditBatchFileModal: {
    show: false,
    data: {},
  },
  addEditSheetConfigModal: {
    show: false,
    data: {},
  },
  addEditBatchEndpointModal: {
    show: false,
    data: {},
  },
  addEditBatchEndpointChildModal: {
    show: false,
    data: {},
  },
};

export default STATE;
